import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router/router.js'; // 导入路由文件
import i18n from './lang/index' // internationalization
import store from './store'; // 导入 Vuex 存储
import axios from 'axios';

Vue.prototype.$axios = axios;
Vue.prototype.$store = store;

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});


// axios.defaults.baseURL = 'http://192.168.31.143:8085/api'
// axios.defaults.baseURL = 'http://192.168.30.211:8085/api'

// axios.defaults.baseURL = 'http://8.138.137.245:8087/api'
// axios.defaults.baseURL = 'http://47.106.233.109:8085/api'
axios.defaults.baseURL = 'https://www.genhey.com/api'
// axios.defaults.baseURL = 'http://127.0.0.1:8087/api'

// 请求拦截器c
axios.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        return response;
    },
    error => {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

new Vue({
    store, // 注册 Vuex
    i18n,
    router,
    render: h => h(App),
}).$mount('#app');
